// Every route that belongs to the Learn tab: Masterclass, Market & Sales (Insiders Academy
// modules) and the Developer Vault briefings.
export const LEARN_PATH_PREFIXES = [
  '/learn',
  '/masterclass/onboarding',
  '/sales-training',
  '/developer-vault',
  '/vault',
] as const;

export const isLearnPath = (path: string): boolean => LEARN_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
